export default function Hero() {
  const t = useI18n()

  return (
    <div className='container px-3 pt-5'>
      <div className='text-[1.5rem] py-3'>{ t('page:academy.hero.title') }</div>
      <div className='text-gray-500 pb-6'>{ t('page:academy.hero.description') }</div>
    </div>
  )
}
